import React from 'react';
import { useRecordContext } from 'react-admin';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

const ProgressField = () => {
    const record = useRecordContext();
    if (!record) return null;

    const progress = record.progress || 0;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: '100px' }}>
                <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{ height: 8, borderRadius: 1 }}
                />
            </Box>
            <Typography variant="body2" sx={{ minWidth: 40, color: '#666' }}>
                {progress}%
            </Typography>
        </Box>
    );
};

export default ProgressField;
